/* eslint-disable @typescript-eslint/camelcase */

import logger from '@/plugins/loglevel';

enum GTMEvent {
  DATA_READY_TO_INIT = 'DataReadyToInit',
  CHANGE_USER_ID = 'ChangeUserID',
  LANDING_IMPRESSION = 'LandingImpression',
  LANDING_CLICK = 'LandingClick',
}

enum Params {
  MARKETING = 'MarketingParams',
  USER_ID = 'user_id',
  EVENT = 'event',
  EVENT_PARAMS = 'EventParams',
}

function setGtmData(data: object) {
  logger.debug('Pushing GTM data -->', data);

  window.dataLayer.push(data);
}

function addGtmEvent(eventName: string, params: object = {}) {
  setGtmData({
    [Params.EVENT]: eventName,
    [Params.EVENT_PARAMS]: params,
  });
}

function setGtmUserId(userId: string, eventTrigger = false) {
  const data = {
    [Params.USER_ID]: userId,
  };

  if (eventTrigger) {
    Object.assign(data, {
      [Params.EVENT]: GTMEvent.CHANGE_USER_ID,
    });
  }

  setGtmData(data);
}

function setGtmMarketing(params: object) {
  setGtmData({ [Params.MARKETING]: params });
}

export { GTMEvent, addGtmEvent, setGtmData, setGtmUserId, setGtmMarketing };
